import React, { useEffect, useRef } from 'react';
import cx from 'classnames';
import { isMobile } from 'react-device-detect';
import s from './Names.module.scss';
import UpArrow from '../../../Resources/UpArrow';
import sr from '../../../Helpers/scrollReveal';

const Names = () => {
  const row1 = useRef();
  const row2 = useRef();
  const row3 = useRef();
  const row4 = useRef();
  const row5 = useRef();

  useEffect(() => {
    sr.reveal(
      [row1.current, row2.current, row3.current, row4.current, row5.current],
      {
        easing: 'ease-in',
        origin: 'top',
        interval: 500,
        viewOffset: {
          top: -100000
        }
      }
    );
  }, []);

  return (
    <div className={s.container}>
      <div className={s.row} ref={row1}>
        <div className={s.name}>You</div>
      </div>
      <div className={cx(s.row, s.second)} ref={row2}>
        <div className={s.name}>
          <div className={cx(s.arrow, s.right)}>
            <UpArrow />
          </div>
          Ilya
        </div>
        <div className={s.name}>
          <div className={cx(s.arrow, s.left)}>
            <UpArrow />
          </div>
          Ivan
        </div>
      </div>
      <div className={cx(s.row, s.third)} ref={row3}>
        <div className={s.name}>
          <div className={cx(s.arrow, s.right)}>
            <UpArrow />
          </div>
          Maria
        </div>
        <div className={s.name}>
          <div className={cx(s.arrow, s.right)}>
            <UpArrow />
          </div>
          Thịnh
        </div>
        <div className={s.name}>
          <div className={cx(s.arrow, s.left)}>
            <UpArrow />
          </div>
          Tuyết
        </div>
      </div>
      <div className={cx(s.row, s.fourth)} ref={row4}>
        <div className={s.name}>
          <div className={cx(s.arrow, s.right)}>
            <UpArrow />
          </div>
          John
        </div>
        <div className={s.name}>
          <div className={cx(s.arrow, s.left)}>
            <UpArrow />
          </div>
          Garry
        </div>
      </div>
      <div className={cx(s.row, s.fifth)} ref={row5}>
        <div className={s.name}>
          <div className={cx(s.arrow, s.right)}>
            <UpArrow />
          </div>
          Andrew
        </div>
        <div className={s.name}>
          <div className={cx(s.arrow, s.left)}>
            <UpArrow />
          </div>
          Bill
        </div>
      </div>
    </div>
  );
};

export default Names;
